module.exports = __webpack_public_path__ + "img/minus-icon.80dffb9e.svg";